(function () {
  'use strict';

  var drawer, overlay, sectionWrap;

  function init() {
    drawer = document.getElementById('cd-drawer');
    overlay = document.getElementById('cd-drawer-overlay');
    sectionWrap = document.getElementById('cart-drawer-section');
    if (!drawer) return;

    bindEvents();
  }

  function openDrawer() {
    drawer.classList.add('cd-open');
    overlay.classList.add('cd-open');
    document.body.classList.add('cd-locked');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    drawer.classList.remove('cd-open');
    overlay.classList.remove('cd-open');
    document.body.classList.remove('cd-locked');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function setLoading(isLoading) {
    drawer.classList.toggle('cd-loading', isLoading);
  }

  // Pulls fresh HTML for this section via Shopify's Section Rendering API
  // so items, shipping bar, cross-sell, and the live payment buttons all
  // stay in sync with the real cart — not just a manually patched DOM.
function refreshDrawerSection() {
  var url = window.location.pathname + '?section_id=cart-drawer';
  return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var newInner = doc.getElementById('cd-drawer-inner');
      var currentInner = document.getElementById('cd-drawer-inner');
      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
      }

      var newHeaderCount = doc.getElementById('cd-header-count');
      var currentHeaderCount = document.getElementById('cd-header-count');
      if (newHeaderCount && currentHeaderCount) {
        currentHeaderCount.textContent = newHeaderCount.textContent;
      }

      // Sync the empty/non-empty class on the drawer wrapper so it
      // stays correct after AJAX add/remove/quantity-change actions,
      // not just on the initial page load.
      var newWrapper = doc.getElementById('cart-drawer-section');
      var currentWrapper = document.getElementById('cart-drawer-section');
      if (newWrapper && currentWrapper) {
        currentWrapper.className = newWrapper.className;
      }

      syncSiteHeaderBadge();
    });
}
  // Best-effort update of common theme header cart-count badge selectors,
  // so the little bag icon count outside the drawer also updates.
  function syncSiteHeaderBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
var selectors = [
  '[data-cart-count]',
  '.cart-count-bubble',
  '.cart-count',
  '.cart-link__bubble',
  '.header-cart__count',
  '#CartCount'
];
        selectors.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
      })
      .catch(function () {});
  }

  function addToCartAjax(formData) {
    setLoading(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        return refreshDrawerSection();
      })
      .then(function () {
        setLoading(false);
        openDrawer();
      })
      .catch(function (err) {
        setLoading(false);
        throw err;
      });
  }

  function changeQuantity(key, qty) {
    setLoading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshDrawerSection(); })
      .then(function () { setLoading(false); })
      .catch(function () { setLoading(false); });
  }

  function quickAddVariant(variantId, btnEl) {
    setLoading(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return refreshDrawerSection(); })
      .then(function () {
        setLoading(false);
        if (btnEl) {
          btnEl.textContent = 'Added ✓';
          btnEl.classList.add('cd-added');
        }
      })
      .catch(function (err) {
        setLoading(false);
        console.error('Quick add failed:', err);
      });
  }

  function bindEvents() {
    // Intercept every add-to-cart form on the site
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      var action = form.getAttribute('action') || '';
      var isCartForm = action.indexOf('/cart/add') !== -1 || form.querySelector('[name="add"]');
      if (!isCartForm) return;

      e.preventDefault();
      var submitBtn = form.querySelector('[data-add-to-cart], [type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      var formData = new FormData(form);
      addToCartAjax(formData)
        .catch(function (err) {
          alert(err && err.description ? err.description : 'Could not add item to cart.');
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });

    document.addEventListener('click', function (e) {
      // Header cart icon → open drawer instead of navigating to /cart
      var cartLink = e.target.closest('a[href="/cart"], a[href="/cart/"]');
      if (cartLink) {
        e.preventDefault();
        refreshDrawerSection().then(openDrawer);
        return;
      }

      if (e.target.closest('#cd-close') || e.target === overlay) {
        closeDrawer();
        return;
      }

      var minusBtn = e.target.closest('.cd-qty-minus');
      if (minusBtn) {
        var qtyDown = parseInt(minusBtn.getAttribute('data-qty'), 10);
        changeQuantity(minusBtn.getAttribute('data-key'), Math.max(0, qtyDown));
        return;
      }

      var plusBtn = e.target.closest('.cd-qty-plus');
      if (plusBtn) {
        changeQuantity(plusBtn.getAttribute('data-key'), parseInt(plusBtn.getAttribute('data-qty'), 10));
        return;
      }

      var removeBtn = e.target.closest('.cd-item__remove');
      if (removeBtn) {
        changeQuantity(removeBtn.getAttribute('data-key'), 0);
        return;
      }

      var quickAddBtn = e.target.closest('[data-quick-add-variant]');
      if (quickAddBtn) {
        quickAddVariant(quickAddBtn.getAttribute('data-quick-add-variant'), quickAddBtn);
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();